// React binding for the device-local contact aliases (storage/kvStores.ts,
// the brain's KV-backed KvAliases — docs/09 §10). Uses useSyncExternalStore
// so every screen showing a name (contacts list, Main, recents) and the
// place aliases are managed (contact detail) stay in sync from one source.
// Aliases never leave the device (docs/08 §2).

import { useSyncExternalStore } from 'react';
import { getAliases, onAliasesChanged } from '../../storage/kvStores.js';

export function useAliases(): Readonly<Record<string, string>> {
  return useSyncExternalStore(onAliasesChanged, getAliases, getAliases);
}
